<template>
  <Transition name="fade">
    <div v-if="isVisible" class="modal-center">

      <div class="modal-content">
        <div class="modalheader">
          <h2 v-if="!editMode">{{$t('add_department')}}</h2>
          <h2 v-else>{{$t('edit_department')}}</h2>

          <div @click="onClose" class="close-btn">
            <img class="cross" src="@/assets/images/cross.svg" />
          </div>
        </div>
        <div class="modalbody">
          <input class="form-input" :placeholder="this.$t('department_name')" v-model="departmentData.name">
          <div class="action-row">
            <button class="dark-button" @click="onAction">
              <span v-if="!loading && !editMode">{{$t('add_department')}}</span>
              <span v-if="!loading && editMode">{{$t('update_department')}}</span>
              <VueSpinnerIos v-if="loading" size="20" height="100%" color="#fff" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import SelectBox from "@/components/SelectBox.vue";
import {
  VueSpinnerIos
} from 'vue3-spinners'
import {handleErrorResponse} from "@/utils/utils";
import Switch from "@/components/Switch.vue";
import depService from "@/service/depService";

export default {
  components: {
    Switch,
    SelectBox,
    VueSpinnerIos
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    editMode: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: {
        departmentId: "",
        name: "",
      }
    },
    departments: {
      type: Array,
      default: []
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    },
    companyId:"",
  },
  data() {
    return {
      departmentData: {
        name: "",
        id:"",
      },
      loading: false,
      newDeps: {
        name: "",
      },
    }
  },
  methods: {
    onAction() {
      if (this.editMode) {
        this.handleEditDepartment();
      } else {
        this.handleAddDepartment();
      }
    },
    handleAddDepartment() {
      if (!this.departmentData.name || this.loading || !this.companyId) {
        return;
      }
      console.log(this.companyId);

      this.loading = true;
      depService.addDep({
        name: this.departmentData.name,
        companyId: this.companyId,
      }).then(response => {
        this.loading = false;
        this.$snackbar.add({
          text: this.$t('user_group_added_successfully'),
          type: "success"
        });
        this.departmentData = {
          name: "",
        };
        this.refreshCallback();
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
        this.loading = false;
      })
    },
    handleEditDepartment() {
      if (!this.departmentData.departmentId || !this.departmentData.name || this.loading) {
        return;
      }
      this.loading = true;
      depService.updateDep({
        departmentId: this.departmentData.departmentId,
        name: this.departmentData.name,
      }).then(response => {
        this.loading = false;
        this.$snackbar.add({
          text: this.$t('user_group_updated_successfully'),
          type: "success"
        });
        this.refreshCallback();
      }).catch(error => {
        handleErrorResponse(error, this.$snackbar);
        this.loading = false;
      })
    }
  },
  watch: {
    editData: {
      handler: function (val) {
        if (this.editMode) {
          this.departmentData = val;
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 20px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:12px
}

.modalheader {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.modalheader h2 {
  color: #040C2D;
  text-align: left;
  font-family: euclid_medium, sans-serif;
  font-size: 20px;
  font-style: normal;
  line-height: 24px;
}

.close-btn {
  height: 24px;
  width: 24px;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cross{
  height: 10px !important;
  width: 10px !important;
}

.modalbody {
  width: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modalbody p {
  color: #667085;
  text-align: center;
  align-items: center;
  font-family: euclid_regular, sans-serif;
  font-size: 16px;
  font-style: normal;
  line-height: 24px; /* 150% */
}


.modalbutton span {
  color: #FFF;
  text-align: center;
  font-family: euclid_regular, sans-serif;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.modalbutton.cancel span {
  color: #667085;
  text-align: center;
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}

.action-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.status-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  justify-content: flex-start;
}

.status-text {
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #040C2D;
}

.form-input, .select-box {
  width: 100%;
}

</style>
